import { FETCH_MAIN_MENU } from '../actions';

export default function(state = [], action) {
    switch (action.type) {
        case FETCH_MAIN_MENU:
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/menu_reducer.jsx